<template>
  <div class="wl-dispatch-left">
    <TopTabs :tabsObj="topTitle" />
    <div class="left-body">
      <CustomElScrollbar class="c-scrollbar">
        <DeliveryOrderItem v-for="(item) in dataList" :key="item.id" :data="item" :uavList="uavList"
          :isSelected="!!currentOrder && item.id == currentOrder.id" @click="handleClick(item)"
          :refreshData="getDeliveryOrderList" @detail="handleDeliveryOrderDetail">
        </DeliveryOrderItem>
        <el-empty v-if="dataList.length == 0" :description="$t('wuliu.dispatch.emptyToday')">
          <template slot="image">
            <span></span>
          </template>
        </el-empty>
      </CustomElScrollbar>
      <div style="margin-top: 10px;padding: 0 12px;">
        <el-pagination class="c-el-pagination-blue" background layout="total, prev, pager, next" :total="page.total"
          :pager-count="5" :page-size.sync="page.pageSize" :current-page.sync="page.pageNum" small
          @current-change="getDeliveryOrderList">
        </el-pagination>
      </div>
    </div>
    <el-drawer :visible.sync="drawerVisible" :title="$t('wuliu.dispatch.deliveryDetail')" :size="400" append-to-body direction="rtl"
      class="order-item-detail-drawer">
      <div style="padding:0 16px;height: calc(100% - 30px);position: relative;">
        <CustomElScrollbar style="height: 100%;">
          <DeliveryOrderDetail v-if="drawerVisible && currentOrder" :id="currentOrder.id" />
        </CustomElScrollbar>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import TopTabs from '@/components/topTabs.vue';
import OrderApi from '@/page/business/wuliu/api/order';
import DateUtil from '@/utils/DateUtil';
import DeliveryOrderItem from '../../components/OrderItem/DeliveryOrderItem.vue';
import DeliveryOrderDetail from '../../components/DeliveryOrderDetail.vue';
import { DeliveryOrderStatus } from '../../constants';
import CustomElScrollbar from '@/components/custom-el-scrollbar/CustomElScrollbar.vue';

export default {
    components: {
        TopTabs,
        DeliveryOrderItem,
        CustomElScrollbar,
        DeliveryOrderDetail,
    },
    props: {},

    data() {
        return {
            currentOrder: null,
            dataList: [],
            drawerVisible: false,
            page: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            uavList: [], // 无人机选项列表

        };
    },
    computed: {
        topTitle() {
            return {
                centre: this.$t('wuliu.dispatch.deliveryOrder'),
            };
        },
    },
    methods: {
        handleClick(item) {
            if (this.currentOrder && this.currentOrder.id == item.id) {
                this.currentOrder = null;
                this.$emit('listItemClick', null);
                return;
            }
            this.currentOrder = item;
            this.$emit('listItemClick', item);
        },
        handleDeliveryOrderDetail(data) {
            this.currentOrder = data;

            this.drawerVisible = true;
        },
        /**
    * 获取配送单列表
    */
        getDeliveryOrderList(page) {
            const { beginTime, endTime } = this.getQueryTime();
            if (page) {
                this.page.pageNum = page;
            } else {
                this.page.pageNum = 1;
            }
            let status = [
                DeliveryOrderStatus.MOUNTED.value,
                DeliveryOrderStatus.DELIVERING.value,
                DeliveryOrderStatus.DELIVERED.value,
                DeliveryOrderStatus.WAITING_RETURN.value,
                DeliveryOrderStatus.RETURNING.value,
            ];
            let params = {
                status: status.join(','),
                orderByColumn: 'orderTime',
                beginTime,
                endTime,
                pageNum: this.page.pageNum,
                pageSize: this.page.pageSize,
                isAsc: 'desc', // 是否升序  asc：升序，desc：降序
            };
            this.loading = true;

            setTimeout(() => {
                this.loading = false;
            }, 1000 * 5);
            OrderApi.fetchDeliveryOrderList(params).then((res) => {
                this.loading = false;
                this.dataList = [];
                if (res.code == 200) {
                    this.dataList = res.rows || [];
                    this.page.total = res.total || 0;
                }
            });
        },
        getQueryTime() {
            const today = DateUtil.getToday('YYYY-MM-DD');
            // 最好是根据营业时间来定，这里默认是8点到23点59分59秒，这里暂时用这个时间段来统计数据
            const beginTime = `${today} 06:00:00`;
            const endTime = `${today} 23:59:59`;
            // 开发阶段暂时用一个月前的时间来调试
            // const beginTime = DateUtil.getOneMonthAgo('YYYY-MM-DD 00:00:00')
            return {
                beginTime,
                endTime,
            };
        },
        timerGetData() {
            const self = this;
            clearInterval(this.timerId);

            this.getDeliveryOrderList(self.page.pageNum);
            this.timerId = setInterval(() => {
                this.getDeliveryOrderList(self.page.pageNum);
            }, 1000 * 20);
        },
        getUavList() {
            OrderApi.fetchDroneOptionList().then((res) => {
                if (res.code == 200) {
                    this.uavList = res.data || res.rows || [];
                }
            });
        },
    },
    mounted() {
        this.timerGetData();
        this.getUavList();
    },
};
</script>

<style lang="scss" scoped>
.wl-dispatch-left {
  position: relative;
  height: calc(100%);

  .left-body {
    height: calc(100% - 65px);

    .c-scrollbar {
      height: calc(100% - 45px);
    }
  }
}
</style>
<style lang="scss">
$bgColor: #0D1541;
$bgColor2: #0D134F;
$colorLight: #5bf0fc;
$borderColor: #2e355b;
$hoverBgColor: rgba(91, 240, 252, 0.1);

.order-item-detail-drawer {

  .el-drawer {
    background-color: $bgColor2;
    color: #ffffff;

    &__header {
      color: #ffffff;
      margin-bottom: 20px;
    }

    .el-form-item {
      &__label {
        color: rgba(255, 255, 255, 0.7);
      }
    }

    .el-timeline-item {
      &__content {
        color: #ffffff;
      }
    }

    .timeline-item__label {
      color: rgba(255, 255, 255, 0.7);
    }
  }
}
</style>
